import baseApi from "../api/baseApi";

const courseApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPublicCourses: builder.query({
      query: () => ({
        url: "/public/courses",
        method: "GET",
      }),
    }),
    
    
    
   
    getCourseCatalogAdminSide: builder.query({
      query: (args = {}) => {
        const {
          type = "course",
          search = "",
          category = "",
          status = "",
          priceMin = "",
          priceMax = "",
          page = 1,
          limit = 10,
        } = args;

        const params = {
          type,
          page: String(page),
          limit: String(limit),
        };

        if (search) {
          params.search = search;
        }

        if (category) {
          params.category = category;
        }

        if (status) {
          params.status = status;
        }

        if (priceMin !== "" && priceMin != null) {
          params.priceMin = String(priceMin);
        }

        if (priceMax !== "" && priceMax != null) {
          params.priceMax = String(priceMax);
        }

        return {
          url: "/course/admin",
          method: "GET",
          credentials: "include",
          params,
        };
      },
      providesTags: ["CourseCatalog"],
    }),
    getSingleCourseAdminSide: builder.query({
      query: (courseId) => ({
        url: `/course/admin/${courseId}`,
        method: "GET",
        credentials: "include",
      }),
      providesTags: (result, error, courseId) => [
        { type: "CourseCatalog", id: courseId },
      ],
    }),
    getAllCourseLearningOutcome: builder.query({
      query: (courseId) => ({
        url: `/outcome/getAllCourseLearningOutcome/${courseId}`,
        method: "GET",
        credentials: "include",
      }),
    }),
    createCourseLearningOutcome: builder.mutation({
      query: ({ courseId, outcomeDescription }) => ({
        url: "/outcome/createCourseLearningOutcome",
        method: "POST",
        credentials: "include",
        body: { courseId, outcomeDescription },
      }),
      invalidatesTags: (result, error, { courseId }) =>
        error || !courseId ? [] : [{ type: "CourseCompletion", id: courseId }],
    }),
    createCourseModule: builder.mutation({
      query: (payload) => ({
        url: "/coursemodules/createCourseModule",
        method: "POST",
        credentials: "include",
        body: payload,
      }),
      invalidatesTags: (result, error, { courseId } = {}) =>
        error || !courseId ? [] : [{ type: "CourseCompletion", id: courseId }],
    }),
    createCourse: builder.mutation({
      query: (payload) => ({
        url: "/course/admin",
        method: "POST",
        credentials: "include",
        body: payload,
      }),
      invalidatesTags: ["CourseCatalog"],
    }),
    updateCourseModule: builder.mutation({
      query: ({ courseId, courseModuleId, payload }) => ({
        url: `/coursemodules/updateCourseModule/${courseId}/${courseModuleId}`,
        method: "PATCH",
        credentials: "include",
        body: payload,
      }),
      invalidatesTags: (result, error, { courseId }) =>
        error || !courseId ? [] : [{ type: "CourseCompletion", id: courseId }],
    }),
    updateCourseLearningOutcome: builder.mutation({
      query: ({ courseId, courseOutcomeId, outcomeDescription }) => ({
        url: `/outcome/updateCourseLearningOutcome`,
        method: "PATCH",
        credentials: "include",
        body: { courseId, courseOutcomeId, outcomeDescription },
      }),
      invalidatesTags: (result, error, { courseId }) =>
        error || !courseId ? [] : [{ type: "CourseCompletion", id: courseId }],
    }),
    getCourseModules: builder.query({
      query: (courseId) => ({
        url: `/coursemodules/getCourseModules/${courseId}`,
        method: "GET",
        credentials: "include",
      }),
    }),
    getInstructorsAssignedToACourse: builder.query({
      query: (courseId) => ({
        url: `/instructor/getInstrcutorsAssignedToACourse/${courseId}`,
        method: "GET",
        credentials: "include",
      }),
      providesTags: (result, error, courseId) =>
        courseId ? [{ type: "AssignedInstructors", id: courseId }] : [],
    }),
    removeInstructorFromCourse: builder.mutation({
      query: ({ courseId, instructorId }) => ({
        url: `/course/admin/${courseId}/instructors`,
        method: "DELETE",
        credentials: "include",
        body: { instructorId },
      }),
      invalidatesTags: (result, error, { courseId }) =>
        error || !courseId
          ? []
          : [
              { type: "AssignedInstructors", id: courseId },
              { type: "CourseCompletion", id: courseId },
            ],
    }),
    getInstructorsThatCanBeAssignedToACourse: builder.query({
      query: (courseId) => ({
        url: `/instructor/getInstructorsThatCanBeAssignedToACourse/${courseId}`,
        method: "GET",
        credentials: "include",
      }),
      providesTags: (result, error, courseId) =>
        courseId ? [{ type: "AssignedInstructors", id: courseId }] : [],
    }),
    assignInstructorToACourse: builder.mutation({
      query: ({ courseId, instructorId }) => ({
        url: `/course/admin/${courseId}/instructors`,
        method: "PATCH",
        credentials: "include",
        body: { instructorId },
      }),
      invalidatesTags: (result, error, { courseId }) =>
        error || !courseId
          ? []
          : [
              { type: "AssignedInstructors", id: courseId },
              { type: "CourseCompletion", id: courseId },
            ],
    }),
    getAllPdfsByModule: builder.query({
      query: (courseId) => ({
        url: `/coursepdfmaterial/getAllPdfsByModule/${courseId}`,
        method: "GET",
        credentials: "include",
      }),
      providesTags: (result, error, courseId) => [
        { type: "PdfMaterials", id: courseId },
      ],
    }),
    uploadCoursePdf: builder.mutation({
      query: ({ formData }) => ({
        url: "/coursepdfmaterial/uploadCoursePdf",
        method: "POST",
        credentials: "include",
        body: formData,
      }),
      invalidatesTags: (result, error, { courseId }) =>
        error || !courseId ? [] : [{ type: "PdfMaterials", id: courseId }],
    }),
    updatePdfTitle: builder.mutation({
      query: ({ courseId, pdfId, title }) => ({
        url: `/coursepdfmaterial/updatePdfTitle/${courseId}/${pdfId}`,
        method: "PATCH",
        credentials: "include",
        body: { title },
      }),
      invalidatesTags: (result, error, { courseId }) =>
        error || !courseId ? [] : [{ type: "PdfMaterials", id: courseId }],
    }),
    uploadCourseLecture: builder.mutation({
      query: ({ formData }) => ({
        url: "/courselectures/uploadCourseLecture",
        method: "POST",
        credentials: "include",
        body: formData,
      }),
      invalidatesTags: (result, error, { courseId }) =>
        error || !courseId ? [] : [{ type: "Lectures", id: courseId }],
    }),
    deleteCourseLecture: builder.mutation({
      query: ({ courseId, lectureId }) => ({
        url: `/courselectures/deleteLecture/${courseId}/${lectureId}`,
        method: "PATCH",
        credentials: "include",
      }),
      invalidatesTags: (result, error, { courseId }) =>
        courseId ? [{ type: "Lectures", id: courseId }] : ["Lectures"],
    }),
    deleteCourseLecturePermanently: builder.mutation({
      query: ({ lectureId }) => ({
        url: `/courselectures/deleteLecturePermanently/${lectureId}`,
        method: "DELETE",
        credentials: "include",
      }),
      invalidatesTags: (result, error, { courseId }) =>
        courseId ? [{ type: "Lectures", id: courseId }] : ["Lectures"],
    }),
    getAllLecturesByModule: builder.query({
      query: (courseId) => ({
        url: `/courselectures/getAllLecturesByModule/${courseId}`,
        method: "GET",
        credentials: "include",
      }),
      providesTags: (result, error, courseId) =>
        courseId ? [{ type: "Lectures", id: courseId }] : ["Lectures"],
    }),
    publishCourse: builder.mutation({
      query: (courseId) => ({
        url: `/course/admin/${courseId}/publish`,
        method: "PATCH",
        credentials: "include",
      }),
      invalidatesTags: (result, error, courseId) =>
        error
          ? []
          : [
              "CourseCatalog",
              { type: "CourseCatalog", id: courseId },
              { type: "CourseCompletion", id: courseId },
            ],
    }),
    updateCourseBasicInformation: builder.mutation({
      query: ({ courseId, payload }) => ({
        url: `/course/admin/${courseId}`,
        method: "PATCH",
        credentials: "include",
        body: payload,
      }),
      invalidatesTags: (result, error, { courseId }) =>
        error
          ? []
          : ["CourseCatalog", { type: "CourseCompletion", id: courseId }],
    }),
    toggleCourseVisibility: builder.query({
      query: (courseId) => ({
        url: `/course/admin/${courseId}/visibility`,
        method: "PATCH",
        credentials: "include",
      }),
    }),
    getCourseCompletion: builder.query({
      query: (courseId) => ({
        url: `/course/admin/${courseId}/completion`,
        method: "GET",
        credentials: "include",
      }),
      providesTags: (result, error, courseId) =>
        courseId ? [{ type: "CourseCompletion", id: courseId }] : [],
    }),

    deleteCourse: builder.mutation({
      query: (courseId) => ({
        url: `/course/admin/${courseId}`,
        method: "DELETE",
        credentials: "include",
      }),
      invalidatesTags: ["CourseCatalog"],
    }),

    restoreCourse: builder.mutation({
      query: (courseId) => ({
        url: `/course/admin/${courseId}/restore`,
        method: "PATCH",
        credentials: "include",
      }),
      invalidatesTags: ["CourseCatalog"],
    }),
  }),
});

export const {
  useGetPublicCoursesQuery,

  useGetCourseCatalogAdminSideQuery,

  useGetSingleCourseAdminSideQuery,

  useGetAllCourseLearningOutcomeQuery,
  useCreateCourseLearningOutcomeMutation,
  useUpdateCourseLearningOutcomeMutation,
  useCreateCourseModuleMutation,
  useCreateCourseMutation,
  useUpdateCourseModuleMutation,

  useGetCourseModulesQuery,

  useGetInstructorsAssignedToACourseQuery,
  useRemoveInstructorFromCourseMutation,
  useGetInstructorsThatCanBeAssignedToACourseQuery,
  useAssignInstructorToACourseMutation,
  useGetAllPdfsByModuleQuery,
  useUploadCoursePdfMutation,
  useUpdatePdfTitleMutation,
  useUploadCourseLectureMutation,
  useDeleteCourseLectureMutation,
  useDeleteCourseLecturePermanentlyMutation,
  useGetAllLecturesByModuleQuery,
  usePublishCourseMutation,
  useUpdateCourseBasicInformationMutation,

  useLazyToggleCourseVisibilityQuery,
  useDeleteCourseMutation,
  useRestoreCourseMutation,
  useGetCourseCompletionQuery,
} = courseApi;
